module.exports = __webpack_public_path__ + "img/bannerPc-2-2.822a68c3.png";